export default __webpack_public_path__ + "static/media/instagram-logo.dc088f03.png";